<template>
  <div class="side_selected_title">
    未選択
  </div>
</template>
